import { Heart, MessageCircle, Send, Bookmark, Music } from 'lucide-react';
import { FaInstagram } from 'react-icons/fa';
import { PreviewCardShell } from './PreviewCardShell';

interface InstagramReelMockupProps {
  hook?: string;
  caption?: string;
  views?: string;
  likes?: string;
  comments?: string;
  username?: string;
  audioName?: string;
  previewLabel?: string;
  hideShell?: boolean;
}

export const InstagramReelMockup = ({
  hook = 'Reel hook text...',
  caption = 'Reel caption #hashtag',
  views = '0',
  likes = '0',
  comments = '0',
  username = '@username',
  audioName = 'Original Audio',
  previewLabel = 'Instagram Reel Preview',
  hideShell = false,
}: InstagramReelMockupProps) => {
  const content = (
    <div className="relative bg-gradient-to-br from-purple-900 to-pink-900" style={{ aspectRatio: '9/16' }}>
        {/* Hook text at top */}
        <div className="absolute top-4 left-4 right-16 z-10">
          <p className="text-white text-lg font-bold drop-shadow-lg line-clamp-2">{hook}</p>
        </div>

        {/* Right sidebar actions */}
        <div className="absolute right-2 bottom-24 flex flex-col gap-5 items-center">
          <div className="flex flex-col items-center">
            <Heart className="w-7 h-7 text-white mb-1" />
            <span className="text-white text-xs font-semibold">{likes}</span>
          </div>
          <div className="flex flex-col items-center">
            <MessageCircle className="w-7 h-7 text-white mb-1" />
            <span className="text-white text-xs font-semibold">{comments}</span>
          </div>
          <div className="flex flex-col items-center">
            <Send className="w-7 h-7 text-white mb-1" />
          </div>
          <div className="flex flex-col items-center">
            <Bookmark className="w-7 h-7 text-white" />
          </div>
        </div>

        {/* Bottom caption area */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 pt-8">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 rounded-full p-0.5 bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF]">
              <div className="w-full h-full rounded-full bg-gradient-to-br from-purple-400 to-pink-400" />
            </div>
            <span className="text-white font-semibold text-sm">{username}</span>
          </div>
          <p className="text-white text-sm line-clamp-2 mb-1">{caption}</p>

          {/* Audio */}
          <div className="flex items-center gap-1.5 text-white text-xs">
            <Music className="w-3 h-3" />
            <span>{audioName}</span>
          </div>

          <div className="text-zinc-300 text-xs mt-1">{views} views</div>
        </div>
    </div>
  );

  if (hideShell) {
    return content;
  }

  return (
    <PreviewCardShell
      className="mx-auto mb-3 w-full max-w-sm"
      badgeClassName="bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737]"
      badge={<FaInstagram className="h-4 w-4 text-white" />}
      label={previewLabel}
    >
      {content}
    </PreviewCardShell>
  );
};
